// extracted by css-extract-rspack-plugin
export default {"toggleContainer":"hierarchy-toggle-module__toggleContainer__PGEFt"};